/* eslint-disable import/no-import-module-exports */
// eslint-disable-next-line import/no-extraneous-dependencies
import ReactDOM from 'react-dom/client';
import './_index.scss';
import { Provider } from 'react-redux';
import { store } from 'app/store';
import { AuthProvider } from 'context/AuthContext';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>
  </HelmetProvider>,
);
